import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const accountSetupApi = async (inputData, authHeaders) => {
    return await apiCallPost(apiPaths.accountSetup, inputData, authHeaders);
};
